import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This error indicates that the SDK instance has been torn down and cleaned up.`}</p>
    <p>{`It means that checkout UI is removed from the DOM. UniversalCheckout instance is also torn down, which will raise an error if any operation that requires the UI is attempted.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      